export default function WinFormInput({children, style = {}, id}) {

    return (
        <div id={id} style={{backgroundColor: 'white', border: '1px solid #cfcfcf', width: 80, height: 20, paddingLeft: 2, ...style}}>
            {children}
        </div>
    )
}